<template>
  <div class="w-[500px] h-[700px] relative overflow-hidden">
    <div class="shadow-sm border border-[#E2E1E3] bg-white flex flex-col items-center absolute top-0 left-0 origin-top-left scale-[.63] px-[12mm] pt-[11mm] w-[793px] h-[1122px]">
      <div class="flex flex-col items-center my-40">
        <AppImgPlaceholder
          :src="plan.logo"
          class="!h-[75mm] mb-12"
        />

        <h1 class="text-[50pt] font-semibold text-black mb-10">
          DDM One Plan
        </h1>

        <h4 class="text-[12pt] mb-[1mm] font-semibold text-black">
          District: {{ plan.district?.name }}
        </h4>

        <h4 class="text-[12pt] mb-[1mm] font-semibold text-black">
          Last Published: {{ formatShortDateAndTime(plan.lastPublishedAt) }}
        </h4>
      </div>

      <div class="w-full flex items-center justify-between [&>div]:h-[160px]">
        <AppImgPlaceholder :src="coatOfArms" />

        <AppImgPlaceholder :src="plan.provincialLogo" />

        <AppImgPlaceholder :src="saDDM" />
      </div>

      <div class="absolute bottom-[3mm] left-0 w-full flex h-[3mm]">
        <div
          v-for="color in ['bg-black', 'bg-green-700', 'bg-orange-700', 'bg-blue-700', 'bg-yellow-400']"
          :key="color"
          :class="color"
          class="h-full flex-1"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { AppImgPlaceholder } from '@/components/app';
import { useDateFormatter } from '@/composables/index.js';
import coatOfArms from '@/assets/images/pdf/coatOfArms.png';
import saDDM from '@/assets/images/pdf/saDDM.png';

const { formatShortDateAndTime } = useDateFormatter();

const props = defineProps({
  plan: {
    type: Object,
    default: () => ({}),
  },
});
</script>
